import React from 'react';
import { motion } from 'framer-motion';
import { ScrollButton } from './Shared';
type Bonus = {
  id: number;
  emoji: string;
  title: string;
  desc: string;
  bookBg: string;
  bookSpine: string;
};
const bonuses: Bonus[] = [{
  id: 1,
  emoji: '📋',
  title: 'El Planner de Sesiones 360',
  desc: 'Plantillas de planificación diaria, semanal y mensual listas para imprimir. Nunca más improvises qué dar el lunes a la mañana.',
  bookBg: 'bg-[#7C9070]',
  bookSpine: 'bg-[#5F7256]'
}, {
  id: 2,
  emoji: '🗣️',
  title: 'El Arte de los Cues',
  desc: '100+ frases sensoriales e imaginarias organizadas por zona corporal. Corregí a tus alumnos sin tocarlos y sin repetir siempre lo mismo.',
  bookBg: 'bg-[#C86B5E]',
  bookSpine: 'bg-[#A65347]'
}, {
  id: 3,
  emoji: '⚡',
  title: 'Pilates Express 20 Minutos',
  desc: '8 clases completas de 20 minutos para el alumno que dice que no tiene tiempo. Reformer · Mat · Sin equipamiento · Adulto mayor.',
  bookBg: 'bg-[#D4A24A]',
  bookSpine: 'bg-[#A87E36]'
}, {
  id: 4,
  emoji: '🔧',
  title: 'Reformer + Props',
  desc: 'Cómo integrar bandas elásticas, pesas livianas y aro de Pilates a tus sesiones para multiplicar el estímulo sin cambiar el método.',
  bookBg: 'bg-[#3D5A6C]',
  bookSpine: 'bg-[#2A4150]'
}, {
  id: 5,
  emoji: '🛡️',
  title: 'Checklist de Seguridad y Lesiones',
  desc: 'Guía rápida de decisión clínica. Semáforo de dolor, patologías frecuentes y protocolo de derivación para no cometer errores con la salud de tus alumnos.',
  bookBg: 'bg-[#8B3A4E]',
  bookSpine: 'bg-[#6B2C3C]'
}, {
  id: 6,
  emoji: '🦴',
  title: 'Anatomía Visual: Músculos en Acción',
  desc: 'Mapa muscular de los 20 ejercicios más usados en Reformer y Mat. Sabé exactamente qué músculo trabaja en cada ejercicio y dá el cue correcto en segundos.',
  bookBg: 'bg-[#6B5B8C]',
  bookSpine: 'bg-[#4F4368]'
}];
const BookCover = ({
  bonus
}: {
  bonus: Bonus;
}) => <div className="relative mx-auto w-44 sm:w-48 aspect-[2/3] drop-shadow-xl" data-id="element-28" data-mp="3cjpqj5ln96r9">
    {/* Spine */}
    <div className={`absolute left-0 top-0 bottom-0 w-3 ${bonus.bookSpine} rounded-l-md`} data-id="element-29" data-mp="3hh81f1j81w1w" />
    {/* Cover */}
    <div className={`absolute left-3 top-0 right-0 bottom-0 ${bonus.bookBg} rounded-r-md flex flex-col p-5 text-white`} data-id="element-30" data-mp="3lkw9dlbrmtno">
      <div className="text-3xl mb-3" data-id="element-31" data-mp="3qglavu7cikmm">{bonus.emoji}</div>
      <div className="font-serif font-bold text-2xl" data-id="element-32" data-mp="2ttge72w57ylu">Bonus {bonus.id}</div>
      <div className="mt-auto" data-id="element-33" data-mp="2xtqrl0m9lraq">
        <div className="h-px bg-white/30 mb-3" data-id="element-34" data-mp="2xutjnbvbpzs8" />
        <div className="text-[10px] tracking-[0.2em] font-semibold opacity-90" data-id="element-35" data-mp="32t3floovh4ew">
          PILATES 360™
        </div>
      </div>
    </div>
  </div>;
export const Bonuses = () => {
  return <section className="py-20 bg-brand-cream" data-id="element-36" data-mp="37lo8mnzyfdhd">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37" data-mp="2a3eelbc5x4da">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16" data-id="element-38" data-mp="2f2qzhqjh41d8">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-brand-charcoal mb-5 leading-tight" data-id="element-39" data-mp="2f1fu5madqlk0">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-xl mx-auto" data-id="element-40" data-mp="22lydf1tx3xyc">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-flex items-center gap-2 bg-brand-terracotta text-white font-bold px-7 py-3.5 rounded-full text-base sm:text-lg shadow-lg shadow-brand-terracotta/30" data-id="element-41" data-mp="1tk8mry7v131m">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        {/* Bonus Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-20" data-id="element-42" data-mp="1jsca9i511adv">
          {bonuses.map((bonus, i) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white rounded-3xl shadow-sm border border-brand-sand p-8 flex flex-col items-center text-center" data-id="element-43" data-mp="19w96y8yfv5pc" data-mpi={i}>
              <div className="py-4" data-id="element-44" data-mp="2r6y6oap3zmjo">
                <BookCover bonus={bonus} data-id="element-45" data-mp="2r5wug2wcwu0d" />
              </div>

              <div className="inline-block bg-green-100 text-green-700 font-bold text-xs tracking-wider px-4 py-1.5 rounded-full mt-4 mb-5" data-id="element-46" data-mp="2w62f2z47lg8y">
                GRATIS
              </div>

              <h3 className="text-xl sm:text-2xl font-serif font-bold text-brand-charcoal mb-4 leading-snug" data-id="element-47" data-mp="2m96dzegn3wef">
                {bonus.emoji} Bonus {bonus.id} — {bonus.title}
              </h3>

              <p className="text-gray-600 leading-relaxed" data-id="element-48" data-mp="2d7q375lwxs9o">{bonus.desc}</p>
            </motion.article>)}
        </div>

        {/* Mid CTA (extra strategic button) */}
        <div className="max-w-4xl mx-auto bg-brand-terracotta rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-49" data-mp="bgv2bzcun2w3">
          <div className="absolute inset-0 bg-black/10" data-id="element-50" data-mp="llv0wbnszcez" />
          <div className="relative z-10" data-id="element-51" data-mp="glp7apxz3fu9">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-6" data-id="element-52" data-mp="gmrvgq3wv46h">
              🔥 Asegurá tu lugar antes de que termine la oferta
            </h3>
            <ScrollButton className="w-full sm:w-auto bg-white text-brand-terracotta hover:bg-brand-sand text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-all transform hover:-translate-y-1" data-id="element-53" data-mp="pmnbb88evncu">
              QUIERO ACCEDER AL MEGAPACK ÉLITE AHORA →
            </ScrollButton>
          </div>
        </div>
      </div>
    </section>;
};